<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" :model="searchForm" label-width="90px" size="mini">
        <el-form-item label="时间范围:">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
            @change="dateRangeChange"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="分子公司:">
          <el-select v-model="searchForm.subcompanyCode" filterable clearable placeholder="请选择" @change="zigsChangeCX">
            <el-option v-for="item in getCompany" :label="item.companyName" :value="item.companyCode" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门:" >
          <el-select v-model="searchForm.departmentCode" filterable clearable placeholder="请选择">
            <el-option v-for="item in bumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchForm')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent"
       highlight-current-row center border :cell-style="setCellStyle" :span-method="objectSpanMethod">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="createSubcompanyName" label="子公司" width="120"></el-table-column>
        <el-table-column prop="createDepartmentName" label="部门" width="120"></el-table-column>
        <el-table-column prop="projectType" label="所属项目" width="120"></el-table-column>
        <!-- <el-table-column prop="jhl" label="计划量"></el-table-column>
        <el-table-column prop="liquidatedAmount" label="完成量"></el-table-column>
        <el-table-column prop="residualWeight" label="剩余量"></el-table-column>
        <el-table-column prop="wcl" label="完成率(%)"></el-table-column> -->
        <el-table-column prop="cycs" label="参与车数"></el-table-column>
        <el-table-column prop="lyts" label="拉运趟数"></el-table-column>
        <el-table-column prop="grossRevenue" label="收入总额(元)"></el-table-column>
        <el-table-column prop="freightAmountTotal" label="支出总额(元)"></el-table-column>
        <el-table-column prop="difference" label="毛利润(元)"></el-table-column>
      </el-table>
    </div>
    <!-- 分页-->
    <div>
      <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[10, 20, 25, 50, 100]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination> -->
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { findProjectTransportation } from '@/api/newTMS'
import { dateFormat1, dateTimeFormat, emptyFn, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getCurrUserDepartment, getCurrUserRightCompany } from '@/api/newCrm'
export default {
  name: 'BasicMeterial',
  components: { },
  data () {
    return {
      toFixed: toFixed,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      searchForm: {
      },
      tableList: [],
      teamNames: [],
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: [],
      h: '',
      isDaoChu: false,
      getCompany: [],
      bumenList: [],
      dateRange: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/xiangmulayuntongji')
    // 初始化默认时间范围（当月第一天到今天）
    this.dateRange = this.getDefaultDateRange()
    if (this.dateRange && this.dateRange.length === 2) {
      this.searchForm.startTime = this.dateRange[0]
      this.searchForm.endTime = this.dateRange[1]
    }
    getCurrUserRightCompany().then(res => { this.getCompany = res })
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 140 + 'px'
  },
  methods: {
    // 获取默认日期范围（最近30天）
    getDefaultDateRange () {
      const today = new Date()
      const thirtyDaysAgo = new Date()
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 29)
      const format = (d) => {
        const y = d.getFullYear()
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${y}-${m}-${day}`
      }
      return [format(thirtyDaysAgo) + ' 00:00:00', format(today) + ' 23:59:59']
    },
    // 日期范围变化
    dateRangeChange (val) {
      if (!val || val.length !== 2) {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
        return
      }
      const [start, end] = val
      // 验证时间跨度不超过1年
      const startDate = new Date(start)
      const endDate = new Date(end)
      const oneYearLater = new Date(startDate)
      oneYearLater.setFullYear(oneYearLater.getFullYear() + 1)
      if (endDate > oneYearLater) {
        this.$message.warning('时间跨度不可超过1年')
        this.dateRange = []
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
        return
      }
      this.searchForm.startTime = start
      this.searchForm.endTime = end
    },
    // 子公司更改
    zigsChangeCX (e) {
      getCurrUserDepartment({ compayCode: e, isQueryDept: 0 }).then(res => { this.bumenList = res })
      this.$set(this.searchForm, 'departmentName', '')
    },
    // 设置单元格样式
    setCellStyle ({ row, column, rowIndex, columnIndex }) {
      // 判断 teamName 是否为"合计"
      if (row.projectType === '小计') {
        // 如果是序号列，将内容设为空字符串
        if (column.type === 'index') {
          return {
            color: '',
            fontWeight: '',
            '&::before': {
              content: '""' // 伪元素方式清空内容
            }
          }
        }
        return {
          color: '#1890ff',
          fontWeight: 'bold'
        }
      }
      return null
    },
    getYesterday () {
      const date = new Date()
      date.setDate(date.getDate() - 1)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }, // 合并单元格
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'createDepartmentName' || column.property === 'createSubcompanyName') {
        const _row = this.spanArr[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      } else {
        return [1, 1]
      }
    },
    // 生成合并规则数组
    getSpanArr (data) {
      this.spanArr = []
      let pos = 0
      data.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1)
          pos = 0
        } else {
          if (item.createDepartmentName === data[index - 1].createDepartmentName) {
            this.spanArr[pos] += 1
            this.spanArr.push(0) // 0表示该行被合并
          } else {
            this.spanArr.push(1)
            pos = index
          }
        }
      })
    },
    masterList () {
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      findProjectTransportation(this.searchForm)
        .then(res => {
          this.tableList = res.list
          let json = {
            projectType: '小计',
            cycs: res.allCycs,
            difference: res.allDifference,
            freightAmountTotal: res.allFreightAmountTotal,
            grossRevenue: res.allGrossRevenue,
            jhl: res.allJhl,
            liquidatedAmount: res.allLiquidatedAmount,
            lyts: res.allLyts,
            residualWeight: res.allResidualWeight
          }
          this.tableList.push(json)
          this.getSpanArr(this.tableList)
          loading.close()
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    searchFn () {
      this.masterList()
    },
    // 重置
    resetForm (formName) {
      this.searchForm = {}
      // 初始化默认时间范围（当月第一天到今天）
      this.dateRange = this.getDefaultDateRange()
      if (this.dateRange && this.dateRange.length === 2) {
        this.searchForm.startTime = this.dateRange[0]
        this.searchForm.endTime = this.dateRange[1]
      }
      this.searchFn()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.masterList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.masterList()
    },
    // 导出
    exportFn () {
      let form = { ...this.searchForm }
      exportExcel(
        this.global.tmsPlus + '/reportw/findProjectTransportationExcel',
        form,
        '项目拉运统计'
      )
      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>

<style scoped lang="less">
</style>
